import React, { Component } from 'react';
import axios from 'axios';

import {
  NavLink,
  Redirect
} from 'react-router-dom';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      password2: '',
      success: '',
      error: '',
      redirect: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value
    })
  }

  handleSubmit(event) {
    event.preventDefault();

    var self = this;

    axios.post('https://randevuapi.uzmdrzelihaaksoy.com/user/login?_format=json', {
      name: this.state.name,
      pass: this.state.password
    })
    .then(function (response) {
      self.setState({
        'success': 'Login successful',
        'error': ''
      });

      localStorage.setItem('username', response.data.current_user.name);
      localStorage.setItem('uid', response.data.current_user.uid);
      localStorage.setItem('roles', JSON.stringify(response.data.current_user.roles || []));
      localStorage.setItem('csrf_token', response.data.csrf_token);
      localStorage.setItem('logout_token', response.data.logout_token);
      localStorage.setItem('auth', window.btoa(self.state.name + ':' + self.state.password));
      window.dispatchEvent(new Event('auth-changed'));

      self.setState({redirect: true});
    })
    .catch(function (error) {
      var errorResponse = error.response && error.response.data && error.response.data.message;
      errorResponse = (errorResponse || 'Giriş başarısız oldu. Lütfen tekrar deneyiniz.').replace(/(?:\r\n|\r|\n)/g, '<br />');
      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  }

  render(){

    var loggedIn = localStorage.getItem("auth");

    if (loggedIn) {
      return <Redirect to="/" />;
    }

    return (
      <div className="flex justify-center">
        <div className="w-full max-w-sm">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <div className="text-center text-lg font-bold text-slate-800 mb-1">Lütfen Giriş Yapınız</div>
            <div className="text-center text-sm text-slate-500 mb-5">
              Uygulamaya girebilmek için lütfen e-postanızı ve parolanızı giriniz.
            </div>

            <form onSubmit={this.handleSubmit} className="flex flex-col gap-3">
              <input
                name="name" value={this.state.name} onChange={this.handleChange}
                required type="text" placeholder="E-posta"
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400/40 focus:border-amber-400 transition-all"
              />
              <input
                name="password" value={this.state.password} onChange={this.handleChange}
                required type="password" placeholder="Parola"
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400/40 focus:border-amber-400 transition-all"
              />
              <button type="submit" className="w-full px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-lg shadow-sm transition-colors">
                Giriş Yap
              </button>

              {this.state.success && <p className="text-center text-sm text-emerald-600">{this.state.success}</p>}
              {this.state.error && <p className="text-center text-sm text-red-600" dangerouslySetInnerHTML={{__html: this.state.error}} />}

              <NavLink className="text-center text-xs text-slate-500 hover:text-slate-700" to="/user/password">
                Parolamı Unuttum
              </NavLink>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login
